import { useRoute } from '@react-navigation/native';
import { styled, SxProp } from 'dripsy';
import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react';
import { View } from 'react-native';

import { UserProfileTabNavigatorRoutePropType } from '@navigation';
import {
  CollapsibleTabListScene,
  EmptyResultTypeEnum,
  EmptyResultView,
  ListView,
  Separator,
} from '@components';
import { useViewerModel } from '@models/Viewer/ViewerModel';
import { ToastService } from '@services';
import { parseApiError } from '@utils';

const Container = styled(View)({
  flex: 1,
  bg: '$background0',
});

const contentContainerStyle: SxProp = {
  px: ['$6', '$7', '5%'],
  flexGrow: 1,
};

const EmptyResultViewContainer = styled(View)({
  flex: 1,
  maxHeight: [400, 600],
});

type RoutePropType =
  UserProfileTabNavigatorRoutePropType<'UserTracks'>;

export const UserTracksScreen = observer(() => {
  const route = useRoute<RoutePropType>();
  const viewer = useViewerModel();

  // TODO: add logic of list here

  async function refresh() {
    try {
      // TODO: Replace with Promise.all([fetchUser, fetchTracks])
      await viewer.fetchUserById.run(route.params.id);
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  return (
    <Container>
      <CollapsibleTabListScene name={route.name}>
        <ListView<any>
          onRefresh={refresh}
          contentContainerSx={contentContainerStyle}
          keyExtractor={(i) => i.id.toString()}
          data={[]}
          renderItem={() => <Fragment />}
          ListHeaderComponent={() => <Separator size="$7" />}
          ItemSeparatorComponent={() => <Separator size="$7" />}
          ListEmptyComponent={() => (
            <EmptyResultViewContainer>
              <EmptyResultView
                type={EmptyResultTypeEnum.NoUserTracks}
              />
            </EmptyResultViewContainer>
          )}
        />
      </CollapsibleTabListScene>
    </Container>
  );
});
